import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RuleErrorsStreamService {
    ruleErrorsStream = new BehaviorSubject<any[]>([]);
}
